
import * as React from 'react';

  // import BlacklistPharmacistsComponent from './../../../components/pharmacist/blacklistPharmacists/BlacklistPharmacists'
import BlackListtest from '../../../components/pharmacist/blacklistPharmacists/blackListtest'


function BlacklistPharmacists() {
    return (
          <>
            <BlackListtest />
           </>
        
    )
        
    
}

export default BlacklistPharmacists